// Notification sound utility using Web Audio API
// Generates a pleasant two-tone chime — no external file needed

let audioContext = null;

const getAudioContext = () => {
    if (!audioContext) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }
    return audioContext;
};

/**
 * Play a pleasant notification chime sound
 */
export const playNotificationSound = () => {
    try {
        const ctx = getAudioContext();
        const now = ctx.currentTime;

        // First tone (higher)
        const osc1 = ctx.createOscillator();
        const gain1 = ctx.createGain();
        osc1.connect(gain1);
        gain1.connect(ctx.destination);
        osc1.frequency.setValueAtTime(830, now);
        osc1.type = 'sine';
        gain1.gain.setValueAtTime(0.15, now);
        gain1.gain.exponentialRampToValueAtTime(0.01, now + 0.15);
        osc1.start(now);
        osc1.stop(now + 0.15);

        // Second tone (lower, slight delay)
        const osc2 = ctx.createOscillator();
        const gain2 = ctx.createGain();
        osc2.connect(gain2);
        gain2.connect(ctx.destination);
        osc2.frequency.setValueAtTime(1200, now + 0.12);
        osc2.type = 'sine';
        gain2.gain.setValueAtTime(0, now);
        gain2.gain.setValueAtTime(0.12, now + 0.12);
        gain2.gain.exponentialRampToValueAtTime(0.01, now + 0.35);
        osc2.start(now + 0.12);
        osc2.stop(now + 0.35);
    } catch (e) {
        // Audio playback not available (e.g. user hasn't interacted yet)
    }
};

/**
 * Show a browser notification if tab is hidden
 */
export const showBrowserNotification = (title, body) => {
    if (!document.hidden) return;
    if (!('Notification' in window)) return;

    if (Notification.permission === 'granted') {
        new Notification(title, { body, icon: '/favicon.ico' });
    } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
                new Notification(title, { body, icon: '/favicon.ico' });
            }
        });
    }
};
